import { compact } from 'lodash-es';
import { RichTextViewer as QuillRichTextViewer, Typography } from 'seagull';
import { approvalMethodNoticePeriodModel, relationshipModel } from "../../../models";
import { requestAccountantAccessModel } from "../../../models/request-accountant-access";
import styles from "./AgreementTerms.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const TitleTypography = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Typography, {
    weight: "bold",
    as: "span",
    className: styles.titleTypography,
    children: children
  });
};
export function AgreementTerms(props) {
  const {
    relationship
  } = props;
  return /*#__PURE__*/_jsx("div", {
    className: styles.root,
    children: /*#__PURE__*/_jsx("section", {
      className: styles.section,
      children: /*#__PURE__*/_jsx("ul", {
        children: compact([/*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(TitleTypography, {
            children: "Effective date of agreement: "
          }), relationshipModel.formatEffectiveDate(relationship)]
        }), /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(TitleTypography, {
            children: "Payment terms: "
          }), relationshipModel.paymentTermsText(relationship)]
        }), /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(TitleTypography, {
            children: "Amendments: "
          }), approvalMethodNoticePeriodModel.amendmentsDescription(relationship.amendmentsApprovalMethod)]
        }), approvalMethodNoticePeriodModel.isAutoApproval(relationship.invoicesApprovalMethod) && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(TitleTypography, {
            children: "Out of scope charges: "
          }), approvalMethodNoticePeriodModel.invoicesDescription(relationship.invoicesApprovalMethod)]
        }), requestAccountantAccessModel.wasRequested(relationship.requestAccountantAccess) && /*#__PURE__*/_jsxs(Typography, {
          testId: "accountant-access-information",
          children: [/*#__PURE__*/_jsx(TitleTypography, {
            children: "Accountant Access: "
          }), "will allow the ".concat(relationship.vendor.name, " team to view your account information on Anchor, including invoices, agreements, and payments, as well as manage your payment methods. ")]
        }), relationship.extraClause && /*#__PURE__*/_jsxs(Typography, {
          testId: "additional-notes",
          className: styles.noteContainer,
          children: [/*#__PURE__*/_jsx(TitleTypography, {
            children: "Agreement notes: "
          }), /*#__PURE__*/_jsx(QuillRichTextViewer, {
            className: styles.note,
            testId: "extra-clause-rich-text-viewer",
            value: relationship.extraClause
          })]
        })]).map((text, idx) => /*#__PURE__*/_jsx("li", {
          className: styles.listItem,
          children: /*#__PURE__*/_jsx(Typography, {
            children: text
          })
        }, idx))
      })
    })
  });
}